import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./Services/AuthContext";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Views/Dashboard";
import Person from "./Views/Person";
import PersonDetails from "./Views/PersonDetails";
import Cost from "./Views/Cost";
import Finalization from "./Views/Finalization";
import Task from "./Views/Task";
import ChecklistItem from "./Views/ChecklistItem";
import Contractor from "./Views/Contractor";
import DocumentType from "./Views/DocumentType";
import Counter from "./Views/Counter";
import CounterDetails from "./Views/CounterDetails";
import Report from "./Views/Report";
import Notification from "./Views/Notification";
import User from "./Views/User";
import UserDetails from "./Views/UserDetails";
import AddonSold from "./Views/Report/AddonSold";
import InvoiceTodo from "./Views/InvoiceTodo";
import AgreementProtocol from "./Views/AgreementProtocol";
import Venture from "./Views/Venture";
import VentureMilestone from "./Views/Venture/VentureMilestone";
import VenturePayment from "./Views/Venture/VenturePayment";
import VentureDocument from "./Views/Venture/VentureDocument";
import VentureTemplate from "./Views/Venture/VentureTemplate";
import VentureAddon from "./Views/Venture/VentureAddon";
import ProjectAddon from "./Views/Venture/ProjectAddon";
import Project from "./Views/Project";
import ProjectDocument from "./Views/ProjectDocument";
import IngBank from "./Views/Import/IngBank";
import SantanderBank from "./Views/Import/SantanderBank";
import VentureAgreement from "./Views/Venture/VentureAgreement";
import Projects from "./Views/Venture/Projects";
import AgreementCategory from "./Views/AgreementCategory";
import AgreementCategoryVentures from "./Views/AgreementCategoryVentures";
import VentureAgreementDetails from "./Views/Venture/VentureAgreementDetails";
import TaskOpen from "./Views/Tasks/TaskOpen";
import TaskCurrent from "./Views/Tasks/TaskCurrent";
import TaskClosed from "./Views/Tasks/TaskClosed";
import TaskRejected from "./Views/Tasks/TaskRejected";
import Payment from "./Views/Payment";
import PaymentRetention from "./Views/PaymentRetention";
import PaymentArchive from "./Views/PaymentArchive";
import MBankBank from "./Views/Import/MBankBank";
import ProspectingModule from "./Views/Codex/Prospecting";
ReactDOM.render(

  <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
            <Routes>
                <Route exact path="/login" element={<Login />} />
                <Route path="/" element={<App />}>
                    <Route index element={<Dashboard />} />
                    <Route path="/person" element={<Person />} />
                    <Route path="/person/:id" element={<PersonDetails />} />
                    <Route path="/cost" element={<Cost />} />
                    <Route path="/finalization" element={<Finalization />} />
                    <Route path="/task" element={<Task />} >
                        <Route index element={<TaskOpen />} />
                        <Route path="open" element={<TaskOpen />} />
                        <Route path="current" element={<TaskCurrent />} />
                        <Route path="closed" element={<TaskClosed />} />
                        <Route path="rejected" element={<TaskRejected />} />
                    </Route>
                    <Route path="/checklist" element={<ChecklistItem />} />
                    <Route path="/contractor" element={<Contractor />} />
                    <Route path="/document" element={<DocumentType />} />
                    <Route path="/counter" element={<Counter />} />
                    <Route path="/counter/:id" element={<CounterDetails />} />
                    <Route path="/agreement_category" element={<AgreementCategory />} />
                    <Route path="/agreement_category/:id" element={<AgreementCategoryVentures />} />
                    <Route path="/report" element={<Report />} />
                    <Route path="/notification" element={<Notification />} />
                    <Route path="/user" element={<User />} />
                    <Route path="/user/:id" element={<UserDetails />} />
                    <Route path="/report/addon_sold" element={<AddonSold />} />
                    <Route path="/invoice/todo" element={<InvoiceTodo />} />
                    <Route path="/cost/:pid" element={<AgreementProtocol />} />
                    <Route path="/venture/:id" element={<Venture />}>
                        <Route index element={<Projects />} />
                        <Route path="project" element={<Projects />} />
                        <Route path="cost" element={<VentureAgreement />} />
                        <Route path="cost/:aid" element={<VentureAgreementDetails />} />
                        <Route path="protocol/:pid" element={<AgreementProtocol />} />
                        <Route path="milestone" element={<VentureMilestone />} />
                        <Route path="payment" element={<VenturePayment />} />
                        <Route path="document" element={<VentureDocument />} />
                        <Route path="template" element={<VentureTemplate />} />
                        <Route path="addon" element={<VentureAddon />} />
                        <Route path="addon/:addon" element={<ProjectAddon />} />
                    </Route>
                    <Route path="/project/:id" element={<Project />} />
                    <Route path="/project/:id/document/:document" element={<ProjectDocument />} />
                    <Route path="/import/ing" element={<IngBank />} />
                    <Route path="/import/santander" element={<SantanderBank />} />
                    <Route path="/import/mbank" element={<MBankBank />} />
                    <Route path="/payment" element={<Payment />} />
                    <Route path={"/payment/retention"} element={<PaymentRetention />} />
                    <Route path={"/payment/archive"} element={<PaymentArchive />} />
                    {ProspectingModule()}
                </Route>
            </Routes>
        </AuthProvider>
      </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
